import auth, {AuthState} from './modules/auth'
import banks, {BankState} from './modules/banks'
import biz, {BizState} from './modules/biz'
import certificates, {CertificateState} from './modules/certificates'
import clients, {ClientsState} from './modules/clients'
import companies, {CompaniesState} from './modules/companies'
import institutions, {InstitutionsState} from './modules/institutions'
import invitation, {InvitationState} from './modules/invitation'
import invoices, {InvoicesState} from './modules/invoices'
import issue, {IssueState} from './modules/issue'
import layout, {LayoutState} from './modules/layout'
import noti, {NotiState} from './modules/noti'
import notice, {NoticeState} from './modules/notice'
import payment, {PaymentState} from './modules/payment'
import storageFilter, {StorageFilterState} from './modules/storage-filter'
import subsidy, {SubsidyState} from './modules/subsidy'
import taxrefund, {TaxRefundState} from './modules/taxrefund'
import taxes, {TaxesState} from './modules/taxes'
import transfer, {TransferState} from './modules/transfer'
import userAction, {UserActionState} from './modules/user-action'
import userAgent, {UserAgentState} from './modules/user-agent'
import users, {UserState} from './modules/users'
import workflows, {WorkflowState} from './modules/workflows'

import {VueConstructor} from 'vue'
import Vuex, {Store} from 'vuex'
import VuexStorage from '@/lib/vuexStorage'
import gtm from './modules/gtm'
import sentry from './modules/sentry'

export interface State {
  version: string
}

export interface RootState {
  auth: AuthState
  banks: BankState
  biz: BizState
  certificates: CertificateState
  companies: CompaniesState
  taxes: TaxesState
  layout: LayoutState
  payment: PaymentState
  storageFilter: StorageFilterState
  userAgent: UserAgentState
  institutions: InstitutionsState
  invoices: InvoicesState
  clients: ClientsState
  transfer: TransferState
  workflows: WorkflowState
  noti: NotiState
  notice: NoticeState
  userAction: UserActionState
  users: UserState
  invitation: InvitationState
  issue: IssueState
  subsidy: SubsidyState
  taxrefund: TaxRefundState
}

const store = (Vue: VueConstructor) => {
  Vue.use(Vuex)

  // context is a Vue.prototype so we can use $i18n $kakao and etc.
  const context = Vue.prototype

  /**
   * to save state in session-storage, local-storage or cookie
   * @/lib/vuexStorage
   */
  const vuexStorage = new VuexStorage({
    strict: true,
    filter: {
      session: 'storageFilter.session',
      local: 'storageFilter.local',
      // cookie: 'storageFilter.cookie',
    },
  })

  return new Store<State | RootState | any>({
    strict: true,
    state: {
      version: process.env.VUE_APP_VERSION || '0.0.0',
    },
    modules: {
      auth: auth(context),
      banks: banks(context),
      biz: biz(context),
      certificates: certificates(context),
      companies: companies(context),
      taxes: taxes(context),
      layout: layout(context),
      payment,
      storageFilter,
      userAgent: userAgent(context),
      gtm: gtm(context),
      sentry: sentry(context),
      institutions: institutions(context),
      invoices: invoices(context),
      clients: clients(context),
      transfer: transfer(context),
      workflows: workflows(context),
      noti: noti(context),
      notice: notice(context),
      userAction: userAction(context),
      users: users(context),
      invitation: invitation(context),
      issue: issue(context),
      subsidy: subsidy(context),
      taxrefund: taxrefund(context)
    },
    mutations: {
      [vuexStorage.mutationName]: vuexStorage.mutation,
    },
    plugins: [vuexStorage.plugin],
  })
}

export default store
